import { render, staticRenderFns } from "./EffectiveAbandonReport.vue?vue&type=template&id=529f03ff&"
import script from "./EffectiveAbandonReport.vue?vue&type=script&lang=js&"
export * from "./EffectiveAbandonReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports